<span
  class="status-cell__badge badge text-capitalize" 
  [ngClass]="badgeColor">{{ cellTranslation | transloco }}
</span>